// Broker Commission Modeler program terms — TanStack Query hooks. The read
// registers under the co-located key factory; the update mutation invalidates it so
// the form re-seeds from the saved row (and IsOverridden / UpdatedAt refresh).
// Toasts + ApiError rendering happen in the calling page.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  commissionModelerTermsApi,
  type UpdateCommissionModelerTermsRequest,
} from "@/api/portfolioAdmin/commissionModelerTermsApi";
import { commissionModelerTermsKeys } from "@/hooks/portfolioAdmin/commissionModelerTermsKeys";

export function useCommissionModelerTerms() {
  return useQuery({
    queryKey: commissionModelerTermsKeys.detail(),
    queryFn: () => commissionModelerTermsApi.get(),
  });
}

export function useUpdateCommissionModelerTerms() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateCommissionModelerTermsRequest) =>
      commissionModelerTermsApi.update(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: commissionModelerTermsKeys.all });
    },
  });
}
